export var HubSpotSubscriptionTypes;
(function (HubSpotSubscriptionTypes) {
    HubSpotSubscriptionTypes["CONTACT_PROPERTY_CHANGE"] = "contact.propertyChange";
    HubSpotSubscriptionTypes["COMPANY_PROPERTY_CHANGE"] = "company.propertyChange";
})(HubSpotSubscriptionTypes || (HubSpotSubscriptionTypes = {}));
//# sourceMappingURL=hubspot-subscription-types.enum.js.map